<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="danger" :msg="alert.error" />
    <b-row>
      <b-button size="sm" @click="openVehicleModal(0)">{{
        this.$t("geral.create")
      }}</b-button>
    </b-row>

    <b-table
      ref="vehicleTypeTable"
      class="table-nowrap"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :filter="tableFilters"
      :filter-debounce="500"
      :per-page="tablePerPage"
      :current-page="tableCurrentPage"
    >
      <template slot="thead-top" slot-scope="{ fields }">
        <b-tr>
          <b-th
            v-for="field in fields"
            :key="field.filterKey"
            class="vertical-align"
          >
            <div v-if="field.filterKey != 'actions'">
              <b-form-input
                v-if="field.filterKey == 'name'"
                class="dateCreate"
                type="text"
                v-model="tableFilters[field.filterKey]"
              />
              <b-form-select
                v-else-if="field.filterKey == 'active'"
                v-model="tableFilters[field.filterKey]"
                id="perPageSelect"
                :options="optionsBoolean"
              ></b-form-select>
            </div>
          </b-th>
        </b-tr>
      </template>
      <template v-slot:cell(actions)="data">
        <!-- {{ data.item}} -->
        <b-button
          v-if="data.item.active && isRmsType(data.item)"
          size="sm"
          variant="danger"
          @click="activateDesativate(data.item.id)"
          >Desativar</b-button
        >
        <b-button
          v-else-if="!data.item.active && isRmsType(data.item)"
          size="sm"
          @click="activateDesativate(data.item.id)"
          variant="Success"
          >Ativar</b-button
        >
        <b-button
          size="sm"
          @click="openVehicleModal(data.item.id)"
          class="ml-2 btn-checklist"
        >
          Visualizar
        </b-button>
      </template>
    </b-table>

    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>

    <vehicle-type-modal
      ref="vehicleTypeModal"
      @refreshTable="refreshTable"
    ></vehicle-type-modal>
  </div>
</template>

<script>
export default {
  name: "VehicleTypeList",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    VehicleTypeModal: () =>
      import("@/components_rms/vehicle/VehicleType/VehicleTypeModal.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Tipo de veículo salvo com suceso!",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "name",
          filterKey: "name",
          sortable: true,
          label: this.$t("geral.name"),
          thStyle: "width: 150px",
        },
        {
          key: "active",
          filterKey: "active",
          sortable: true,
          label: this.$t("geral.active"),
          thStyle: "width: 50px",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      optionsBoolean: [
        { value: null, text: "Todos" },
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        id: "",
        name: "",
        active: true,
      },
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableRowCount: 0,
    };
  },
  methods: {
    isRmsType(vehicleType) {
      if (vehicleType.companyId == null) {
        if (
          this.$store.getters.companyId == 1 ||
          this.$store.getters.companyId == 177
        ) {
          return true;
        }
      } else if (vehicleType.companyId != null) {
        return true;
      }
      return false;
    },
    refreshTable() {
      this.$refs.vehicleTypeTable.refresh();
      this.$forceUpdate();
    },
    openVehicleModal(vehicleTypeId) {
      this.$refs.vehicleTypeModal.openModal(vehicleTypeId);
    },
    myProvider(ctx, callback) {
      this.isBusy = true;

      let apiFilter = {
        id: ctx.filter.id,
        name: ctx.filter.name,
        active: ctx.filter.active,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        perPage: ctx.perPage,
        currentPage: ctx.currentPage,
      };
      this.$apiVehicle
        .post("/vehicleType/list", apiFilter)
        .then((response) => {
          this.tableRowCount = response.data.totalItems;
          this.isBusy = false;
          this.items = response.data.items;
          callback(this.items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
              this.isBusy = false;
            });
          } else {
            this.tableIsBusy = false;
            this.tableRowCount = 0;
            this.isBusy = false;
            callback([]);
          }
        });
      return null;
    },
    activateDesativate(vehicleTypeId) {
      this.$apiVehicle
        .post("/vehicleType/activateDesactivate/" + vehicleTypeId)
        .then((response) => {
          this.$refs.vehicleTypeTable.refresh();
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.$refs.alert.error.show();
          }

          this.$refs.vehicleTypeTable.refresh();
          this.$forceUpdate();
        });
    },
  },
};
</script>

<style scoped>
/* Your component-specific styles here */
</style>